import './Alignment.css';
export var horizontalAlignment = {right:'_yj6voi0-3-8-0',left:'_yj6voi1-3-8-0',center:'_yj6voi2-3-8-0'};
export var verticalAlignment = {top:'_yj6voi3-3-8-0',center:'_yj6voi4-3-8-0',bottom:'_yj6voi5-3-8-0'};